import { apiClient } from '@app/lib'
import { type SugarPaymentReportsResponse } from '@app/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'
import { useSugarContext } from '@app/providers'

export const usePaymentReports = ({ page }: { page?: number | null | undefined }) => {
  const session = useSession()
  const { siteId } = useSugarContext()

  return useQuery({
    enabled: session.status === 'authenticated' && Boolean(siteId),
    placeholderData: keepPreviousData,
    queryKey: ['payment-reports', { page, siteId }],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarPaymentReportsResponse>('/api/payment-reports', {
        params: {
          page: page ? Math.max(1, page) : 1,
          siteId
        },
        signal
      })

      // Sugar emits HTTP 200 with `success: false` for app-level failures (formatErrorResponse).
      // Surface those through React Query's error state instead of letting `data.length` crash.
      if (!data.success) {
        throw new Error(data.messages?.[0]?.message ?? 'Unable to retrieve payment reports at this time.')
      }

      return data
    }
  })
}
